import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowDownCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-down-circle, arrow-bottom"} maskId="square-filled-radius-0-stroke-1-IconArrowDownCircle"><path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 17.2071L7.79289 13L8.5 12.2929L11.5 15.2929V7H12.5V15.2929L15.5 12.2929L16.2071 13L12 17.2071Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowDownCircle;
